import React, { useContext } from 'react'
import GeoContext from 'contexts/geoContext'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import Group from 'components/utils/Group'
import OfferPackagePartnershipLabel from 'components/Common/Labels/OfferPackagePartnershipLabel'
import FlashCancellationPolicies from 'components/Common/CancellationPolicies/Flash/FlashCancellationPolicies'
import useIsAvailableForPurchase from '../../hooks/useIsAvailableForPurchase'
import FlashHotelCheapestOptionPriceDetailsVariant from './FlashHotelCheapestOptionPriceDetailsVariant'
import LuxLoyaltyPoints from 'luxLoyalty/components/LuxLoyaltyPoints'
import useLuxLoyaltyPointsCalculator from 'luxLoyalty/hooks/useLuxLoyaltyPointsCalculator'
import { generateLuxLoyaltyPointsCalculatorFlightOptions, generateLuxLoyaltyPointsCalculatorHotelOptions } from 'luxLoyalty/lib/pointsCalculation/calculatorOptionsGenerators'

interface Props {
  offer: App.Offer;
  checkIn?: string;
  packageView: OfferPackageOptionView;
  previewMode: boolean;
  detailsModalMode: 'room' | 'room-and-package';
}

function FlashHotelCheapestRateOptionVariant(props: Props) {
  const {
    offer,
    checkIn,
    packageView,
    previewMode,
    detailsModalMode,
  } = props

  const { partnership } = useContext(GeoContext)
  const availableForPurchase = useIsAvailableForPurchase()
  const {
    package: pkg,
  } = packageView

  const showPartnership = (packageView.hotelAvailable &&
    !!partnership?.hasEarn &&
    offer.canEarnPartnershipPoints)

  const showPrices = (packageView.capacityValid && packageView.hotelAvailable) || previewMode

  const { totalPointsCalculation } = useLuxLoyaltyPointsCalculator([
    generateLuxLoyaltyPointsCalculatorHotelOptions(offer, { packageView }),
    generateLuxLoyaltyPointsCalculatorFlightOptions(offer, {
      packageView,
      skip: !offer.bundledWithFlightsOnly,
    }),
  ])

  return (
    <Group direction="vertical" gap={16} data-testid={pkg.uniqueKey}>
      <Group direction="vertical" gap={8} noDisplayWhenEmpty>
        {availableForPurchase && offer.property && pkg.roomRate && <FlashCancellationPolicies
          checkInDate={checkIn}
          propertyTimezoneOffset={offer.property.timezoneOffset}
          cancellationPolicy={pkg.roomRate.cancellationPolicy}
          />}
        {showPrices && <LuxLoyaltyPoints pointsEarnCalculation={totalPointsCalculation} calculationType={!checkIn ? 'estimate' : 'exact'} />}
      </Group>
      <Group direction="vertical" gap={8}>
        {!!showPartnership && pkg.partnership && <OfferPackagePartnershipLabel
          offer={offer}
          price={packageView.hotelPrice}
          packagePartnership={pkg.partnership}
          />}
        {showPrices && <FlashHotelCheapestOptionPriceDetailsVariant
          packageView={packageView}
          detailsModalMode={detailsModalMode}
        />}
      </Group>
    </Group>
  )
}

export default withOfferPageAndReduxState((state: OfferPageState, appState: App.State) => ({
  checkIn: state.checkInDate,
  partnership: appState.geo.partnership,
  previewMode: appState.system.previewMode,
}))(FlashHotelCheapestRateOptionVariant)
